const ConfirmMixin = {
  methods: {
    async $confirm(text = this.$t('cmrad.are_you_sure'), title = this.$t('cmrad.please_confirm')) {
      return await this.$bvModal.msgBoxConfirm(text, {
        title: title,
        className: 'confirm-modal',
        okTitle: this.$t('cmrad.ok'),
        cancelTitle: this.$t('cmrad.cancel'),
        cancelVariant: 'link text-danger',
        okVariant: 'primary confirm-ok-btn',
        headerClass: 'px-3 pb-3',
        bodyClass: 'pt-3',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      });
    },
  },
};

export default ConfirmMixin;
